import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/')({
  component: Index,
});

function Index() {
  return <p>Welcome, Admin!</p>;
}
